import React, { useState } from 'react';
import { useIsMobile, useDocumentType } from '@/utils/hooks';
import BuyerDocumentCardMobile from './BuyerDocumentCardMobile';
import BuyerDocumentCardDesktop from './BuyerDocumentCardDesktop';
import { BuyerDocument, BuyerOfferDocument, TranslatableText, FileMetadata } from '@/types';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FileType } from '@ygtechnologies/rubus-frontend-utilities';
import { getDownloadOriginalDocumentUrl, getOpenDocumentUrl } from '@/services/documents';
import { faBuilding, faHome } from '@fortawesome/pro-light-svg-icons';
import { getDownloadBuyerOfferAttachmentUrl, getOpenBuyerOfferAttachmentUrl } from '@/services/buyer-offers';
import { LightboxSingleImage } from '@ygtechnologies/rubus-ui';

// export type BuyerDocumentCardProps = {
//     document: BuyerDocument;
//     handleLinkClick: (e, document: BuyerDocument) => void;
//     onHistoryClick: (d: BuyerDocument) => void;
// };

export interface BuyerDocumentCardInternalProps {
    onLinkClick?(e): void;
    onHistoryClick?(e): void;
    title: string;
    subTitle: string;
    icon?: IconDefinition;
    lastModified?: Date;
    versionNumber?: number;
    downloadLink: string;
    openLink: string;
    fileMetadata: FileMetadata;
    versionId?: number;
}

const ResponsiveDocumentCard: React.FC<BuyerDocumentCardInternalProps> = (props) => {
    const isMobile = useIsMobile();
    const [lightboxOpen, setLightboxOpen] = useState(false);

    const handleLinkClick = (e) => {
        if (props.fileMetadata.fileType === FileType.Image) {
            e.preventDefault();
            setLightboxOpen(true);
        }
    };

    return (
        <>
            <LightboxSingleImage
                image={{
                    src: props.openLink,
                    thumbnailSrc: props.openLink,
                    title: props.title,
                    type: 'image',
                }}
                open={lightboxOpen}
                setOpen={setLightboxOpen}
            />

            {isMobile ? (
                <BuyerDocumentCardMobile onLinkClick={handleLinkClick} {...props} />
            ) : (
                <BuyerDocumentCardDesktop onLinkClick={handleLinkClick} {...props} />
            )}
        </>
    );
};

export interface BuyerDocumentCardProps {
    document: BuyerDocument;
    onHistoryClick: (e, document: BuyerDocument) => void;
}

export const BuyerDocumentCard: React.FC<BuyerDocumentCardProps> = ({ document, onHistoryClick }) => {
    const documentType = useDocumentType(document.documentTypeId);

    const props: BuyerDocumentCardInternalProps = {
        subTitle: document.name,
        title: documentType ? documentType.name : '',
        fileMetadata: document.fileMetadata,
        lastModified: document.uploadDate,
        versionNumber: document.versionNumber,
        icon: document.isProjectDocument ? faBuilding : faHome,
        openLink: getOpenDocumentUrl(document.versionId),
        downloadLink: getDownloadOriginalDocumentUrl(document.versionId),
        onHistoryClick: (e) => onHistoryClick(e, document),
        versionId: document.versionId,
    };

    return <ResponsiveDocumentCard {...props} />;
};

export interface BuyerOfferDocumentCardProps {
    document: BuyerOfferDocument;
    onLinkClick: (e, document: BuyerOfferDocument) => void;
}

export const BuyerOfferDocumentCard: React.FC<BuyerOfferDocumentCardProps> = ({ document, onLinkClick }) => {
    const props: BuyerDocumentCardInternalProps = {
        title: document.name,
        subTitle: document.fileMetadata.fileType,
        fileMetadata: document.fileMetadata,
        openLink: getOpenBuyerOfferAttachmentUrl(document.buyerOfferAttachmentId),
        downloadLink: getDownloadBuyerOfferAttachmentUrl(document.buyerOfferAttachmentId),
        onLinkClick: (e) => onLinkClick(e, document),
    };

    return <ResponsiveDocumentCard {...props} />;
};
